var _path, _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGoldRank6(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 201 198",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#gold_rank_6_svg__clip0_1947_7007)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "gold_rank_6_svg__a",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 201,
    height: 198
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M200.865.472H0v197.196h200.865V.472z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#gold_rank_6_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.335 38.575c-5.345-5.579-14.621-4.129-18.038 2.784-8.93 18.047-6.153 40.467 8.615 55.888 18.43 19.241 48.732 20.481 68.68 3.191L37.334 38.575z",
    fill: "#FAE185"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.322 75.73C6.903 73.498-.439 79.31.024 86.997c1.201 20.079 14.761 38.208 35.265 44.369 25.585 7.687 52.553-6.103 61.308-30.928l-82.275-24.71z",
    fill: "#F9DD74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.338 121.659c-7.507 1.916-10.76 10.669-6.358 17.005 11.497 16.556 32.546 25.082 53.291 19.794 25.89-6.598 41.771-32.28 36.315-58.02l-42.55 10.844-40.704 10.372.006.005z",
    fill: "#F9D862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.531 38.575c5.344-5.579 14.621-4.129 18.037 2.784 8.931 18.047 6.153 40.467-8.614 55.888-18.43 19.241-48.732 20.481-68.68 3.191l59.257-61.863z",
    fill: "#FAE185"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.543 75.73c7.419-2.231 14.762 3.58 14.305 11.274-1.202 20.079-14.762 38.208-35.266 44.369-25.585 7.687-52.553-6.103-61.308-30.929l82.269-24.715z",
    fill: "#F9DD74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.522 121.659c7.507 1.916 10.759 10.669 6.358 17.005-11.497 16.556-32.547 25.082-53.291 19.794-25.89-6.598-41.77-32.28-36.315-58.02l42.55 10.844 40.704 10.372-.006.005z",
    fill: "#F9D862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.792.472h108.224c6.47 0 11.72 5.218 11.72 11.647V132.24c0 36.106-29.499 65.421-65.832 65.421-36.332 0-65.832-29.315-65.832-65.421V12.119c0-6.43 5.25-11.647 11.72-11.647z",
    fill: "#F8D451"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M63.195 67.623h75.413c4.506 0 8.169 3.634 8.169 8.118v49.098c0 25.164-20.557 45.587-45.873 45.587-25.321 0-45.872-20.429-45.872-45.587V75.741c0-4.478 3.657-8.118 8.169-8.118h-.006z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.608 69.953c3.211 0 5.825 2.597 5.825 5.788v49.098c0 23.853-19.526 43.257-43.529 43.257-24.002 0-43.528-19.404-43.528-43.257V75.741c0-3.191 2.613-5.788 5.825-5.788h75.413m0-2.33h-75.42c-4.511 0-8.168 3.634-8.168 8.118v49.098c0 25.175 20.54 45.587 45.872 45.587 25.334 0 45.873-20.412 45.873-45.587V75.741c0-4.484-3.657-8.118-8.169-8.118h.012z",
    fill: "#fff",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.016.472h-44.982L35.072 74.966v51.323l125.3-124.525a11.72 11.72 0 00-5.356-1.292zM95.712 112.109l71.024-70.581V12.445L81.079 97.567l14.633 14.542z",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M64.25 27.644l1.687 5.154c.188.57.721.955 1.325.955h5.456c1.347 0 1.91 1.718.82 2.504l-4.413 3.186a1.38 1.38 0 00-.504 1.549l1.688 5.153c.416 1.276-1.049 2.336-2.145 1.55l-4.412-3.186a1.406 1.406 0 00-1.635 0l-4.413 3.185c-1.09.787-2.561-.273-2.145-1.549l1.688-5.154a1.383 1.383 0 00-.504-1.548l-4.413-3.186c-1.09-.786-.533-2.504.82-2.504h5.456a1.39 1.39 0 001.325-.955l1.688-5.154c.416-1.275 2.232-1.275 2.648 0h-.017z",
    stroke: "#000",
    strokeWidth: 8,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.25 27.644l1.687 5.154c.188.57.721.955 1.325.955h5.456c1.347 0 1.91 1.718.82 2.504l-4.413 3.186a1.38 1.38 0 00-.504 1.549l1.688 5.153c.416 1.276-1.049 2.336-2.145 1.55l-4.412-3.186a1.406 1.406 0 00-1.635 0l-4.413 3.185c-1.09.787-2.561-.273-2.145-1.549l1.688-5.154a1.383 1.383 0 00-.504-1.548l-4.413-3.186c-1.09-.786-.533-2.504.82-2.504h5.456a1.39 1.39 0 001.325-.955l1.688-5.154c.416-1.275 2.232-1.275 2.648 0h-.017z",
    fill: "#22AEFC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M139.675 27.644l1.687 5.154c.188.57.721.955 1.325.955h5.455c1.348 0 1.911 1.718.821 2.504l-4.413 3.186c-.486.349-.691.978-.504 1.549l1.688 5.153c.416 1.276-1.049 2.336-2.145 1.55l-4.413-3.186a1.406 1.406 0 00-1.635 0l-4.412 3.185c-1.09.787-2.561-.273-2.145-1.549l1.688-5.154a1.384 1.384 0 00-.504-1.548l-4.413-3.186c-1.09-.786-.533-2.504.821-2.504h5.455c.604 0 1.137-.385 1.325-.955l1.687-5.154c.416-1.275 2.233-1.275 2.649 0h-.017z",
    stroke: "#000",
    strokeWidth: 8,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.675 27.644l1.687 5.154c.188.57.721.955 1.325.955h5.455c1.348 0 1.911 1.718.821 2.504l-4.413 3.186c-.486.349-.691.978-.504 1.549l1.688 5.153c.416 1.276-1.049 2.336-2.145 1.55l-4.413-3.186a1.406 1.406 0 00-1.635 0l-4.412 3.185c-1.09.787-2.561-.273-2.145-1.549l1.688-5.154a1.384 1.384 0 00-.504-1.548l-4.413-3.186c-1.09-.786-.533-2.504.821-2.504h5.455c.604 0 1.137-.385 1.325-.955l1.687-5.154c.416-1.275 2.233-1.275 2.649 0h-.017z",
    fill: "#22AEFC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M102.029 19.602l2.034 6.22a1.676 1.676 0 001.6 1.152h6.581c1.629 0 2.303 2.068.984 3.017l-5.321 3.843a1.666 1.666 0 00-.609 1.864l2.033 6.22c.504 1.537-1.266 2.818-2.584 1.863l-5.321-3.843a1.688 1.688 0 00-1.975 0l-5.32 3.843c-1.32.95-3.09-.326-2.585-1.863l2.033-6.22a1.667 1.667 0 00-.61-1.864l-5.32-3.843c-1.319-.95-.639-3.017.984-3.017h6.581c.727 0 1.371-.465 1.6-1.153l2.034-6.22c.503-1.537 2.689-1.537 3.193 0h-.012z",
    stroke: "#000",
    strokeWidth: 8,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.029 19.602l2.034 6.22a1.676 1.676 0 001.6 1.152h6.581c1.629 0 2.303 2.068.984 3.017l-5.321 3.843a1.666 1.666 0 00-.609 1.864l2.033 6.22c.504 1.537-1.266 2.818-2.584 1.863l-5.321-3.843a1.688 1.688 0 00-1.975 0l-5.32 3.843c-1.32.95-3.09-.326-2.585-1.863l2.033-6.22a1.667 1.667 0 00-.61-1.864l-5.32-3.843c-1.319-.95-.639-3.017.984-3.017h6.581c.727 0 1.371-.465 1.6-1.153l2.034-6.22c.503-1.537 2.689-1.537 3.193 0h-.012z",
    fill: "#22AEFC"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "gold_rank_6_svg__clip0_1947_7007"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h201v198H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoldRank6);
export default ForwardRef;